"use client"

import {
  CircleCheck,
  Info,
  LoaderCircle,
  OctagonX,
  TriangleAlert,
} from "lucide-react"
import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      // Use role="status" for non-error toasts, role="alert" for errors
      // Sonner handles this internally, but we ensure proper aria-live regions
      icons={{
        success: <CircleCheck className="h-4 w-4" aria-hidden="true" />,
        info: <Info className="h-4 w-4" aria-hidden="true" />,
        warning: <TriangleAlert className="h-4 w-4" aria-hidden="true" />,
        error: <OctagonX className="h-4 w-4" aria-hidden="true" />,
        loading: <LoaderCircle className="h-4 w-4 animate-spin" aria-hidden="true" />,
      }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:font-medium",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      // Ensure toasts are announced to screen readers
      richColors
      // No close (×): toasts dismiss on their own (Sonner's default ~4s; swipe also dismisses).
      // Designer direction (2026-10-09): toasts appear near the top centre of the window.
      position="top-center"
      {...props}
    />
  )
}

export { Toaster }
